import PlayerNameWithFlag from "../../players/PlayerNameWithFlag";
import {getRatingColorVariant} from "../../../util/HelperUtils";
import {ProgressBar} from "react-bootstrap";
import type {PlayerScore} from "../../../types/domain";

interface RatingTabProps {
  scores: PlayerScore[];
}

function RatingTab(props: RatingTabProps) {

  const sortedRatings = [...props.scores]
  sortedRatings.sort((a, b) => (a.averageRating ?? 0.0) < (b.averageRating ?? 0.0) ? 1 : -1)

  const renderForDesktop = () => {
    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="flex-grow-1 pt-3 pb-5 hide-on-mobile" />
        <div className="flex-grow-1 pt-3 pb-5">
          {sortedRatings.map((playerScore, index) => {
            const player = playerScore.player
            const rating = playerScore.averageRating ?? 0.0;
            return <div className="ps-3 pb-3" key={"rating-" + player.id}>
              <div className="rating-name pb-2 d-flex gap-2">
                <span style={{color: "white"}}>#{index + 1}</span>
                <PlayerNameWithFlag player={player} includeElo={false} aliasOnly={true} />
              </div>
              <ProgressBar label={rating.toFixed(2)} now={rating} max={2.0} min={-0.1}
                           variant={getRatingColorVariant(rating, true)} animated={rating > 2.0} />
            </div>
          })}
        </div>
        <div className="flex-grow-1 pt-3 pb-5 hide-on-mobile" />
      </div>
    )
  }

    return <>
      { renderForDesktop() }
      </>;
}

export default RatingTab
